import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import '../Styles/Contact.css'
import axios from 'axios'
const Contact = () => {
    useEffect(() => {


    }, [])



    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    async function postName(e) {
        const formdata = new FormData()
        formdata.append("name", name)
        formdata.append("email", email)
        e.preventDefault()
        try {
            await axios.post("http://localhost:5000/api/contact", {
                name: name,
                email: email
            }).then(() => {
                setName("")

            })
        } catch (error) {
            setName("")
        }
    }
    return (
        <>
            <div data-aos="flip-right">
                <section className="contact">
                    <div className="container">
                        <h1 className="primary-text">
                            <div data-aos="fade-down">
                                <span className="blast">C</span>
                                <span className="blast">o</span>
                                <span className="blast">n</span>
                                <span className="blast">t</span>
                                <span className="blast">a</span>
                                <span className="blast">c</span>
                                <span className="blast">t</span>
                                ⠀
                                <span className="blast">M</span>
                                <span className="blast">e</span>
                            </div>
                        </h1>
                        <div className="boxes">


                            <div className="forms">
                                <div className="inputs">
                                    <p className='about-text'>
                                        <div data-aos="fade-up">
                                            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Asperiores laudantium, sed delectus perferendis corporis provident recusandae
                                        </div>
                                    </p>

                                    <div className="contact-inputs">
                                        <form onSubmit={postName}>
                                            <div className="name-form">
                                                <div className="border">
                                                    <input type="text" placeholder='Name'
                                                        className='first-input'
                                                        value={name} onChange={(e) => setName(e.target.value)} />
                                                </div>
                                                <div className="border">
                                                    <input type='text' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} />
                                                </div>

                                            </div>
                                            <input type="text" className="subject" placeholder='Subject' />
                                            <input type="text" className="mesage" placeholder='Mesage' />
                                            <a href="#" className="contact-button">
                                                <div>
                                                    <span className="bg" ></span>
                                                    <span className="base"></span>
                                                    <span className="text">
                                                        Contact me!
                                                    </span>
                                                </div>
                                            </a>
                                        </form>
                                    </div>


                                </div>
                                <div className="other-forms">
                                    <div className="box-info">
                                        <div className="container-info">
                                            <div className="icon">
                                                <i className="fa-solid fa-mobile-screen"></i>
                                            </div>
                                            <div className="text-contact">
                                                <h1> Phone Number</h1>
                                                <p>+998) 93 405 8841, (+998) 93 407 8400</p>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="box-info">
                                        <div className="container-info">
                                            <div className="icon">
                                                <i className="fa-solid fa-location-dot"></i>
                                            </div>
                                            <div className="text-contact">
                                                <h1> Location</h1>
                                                <p>Uzbekistan, Samarqand, Payariq</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-info">
                                        <div className="container-info">
                                            <div className="icon">
                                                <ion-icon name="mail-outline"></ion-icon>
                                            </div>
                                            <div className="text-contact">
                                                <h1> Email</h1>
                                                <p>ozodabduvoitov8@gmail.com</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div >
        </>
    );
}
export default Contact;